import { onDestroy } from 'svelte';

export function timePassedComponents(date: number, showPast = false) {
	const now: number = +new Date();
	const inPast = now - date * 1000 > 0;
	var seconds;
	if (showPast && inPast) {
		return 'Delay in starting round. Will start within ' + timePassed(date + 86400 + 6 * 3600);
	}
	if (inPast) seconds = Math.floor((now - date * 1000) / 1000);
	else seconds = Math.floor((date * 1000 - now) / 1000);
	const groupDurations = [31536000, 2592000, 86400, 3600, 60, 1];

	var year = seconds / groupDurations[0];
	var month = (seconds % groupDurations[0]) / groupDurations[1];
	var day = ((seconds % groupDurations[0]) % groupDurations[1]) / groupDurations[2];
	var hour =
		(((seconds % groupDurations[0]) % groupDurations[1]) % groupDurations[2]) / groupDurations[3];
	var minute =
		((((seconds % groupDurations[0]) % groupDurations[1]) % groupDurations[2]) %
			groupDurations[3]) /
		groupDurations[4];
	var second =
		((((seconds % groupDurations[0]) % groupDurations[1]) % groupDurations[2]) %
			groupDurations[3]) %
		groupDurations[4];

	var result = {
		year: Math.floor(year),
		month: Math.floor(month),
		day: Math.floor(day),
		hour: Math.floor(hour),
		minute: Math.floor(minute),
		second: Math.floor(second)
	};
	return result;
}

export function timePassed(date: number, showPast = false) {
	const now: number = +new Date();
	const inPast = now - date * 1000 > 0;
	var resultString;
	var seconds;
	if (showPast && inPast) {
		return 'Delay in starting round. Will start within ' + timePassed(date + 86400 + 6 * 3600);
	}
	if (inPast) seconds = Math.floor((now - date * 1000) / 1000);
	else seconds = Math.floor((date * 1000 - now) / 1000);

	const groups = ['year', 'month', 'day', 'hour', 'minute', 'second'];
	var result: any = timePassedComponents(date, showPast);
	for (var i = 0; i < groups.length; i++) {
		if (result[groups[i]] > 0) {
			resultString = result[groups[i]] + ' ' + groups[i] + (result[groups[i]] > 1 ? 's ' : ' ');
			if (i < groups.length - 1) {
				resultString +=
					result[groups[i + 1]] > 0
						? 'and ' +
						  result[groups[i + 1]] +
						  ' ' +
						  groups[i + 1] +
						  (result[groups[i + 1]] > 1 ? 's' : '')
						: '';
			}
			if (inPast) resultString += ' ago';

			return resultString;
		}
	}
}

export const getTimeTillNextFridayAt8AM = () => {
	// return time till next friday at 8 am
	const now = new Date();
	const nextFriday = +new Date(
		Date.UTC(
			now.getFullYear(),
			now.getMonth(),
			now.getDate() +
				((12 - now.getDay()) % 7 == 0 && now.getUTCHours() > 8 ? 7 : (12 - now.getDay()) % 7),
			8,
			0,
			0
		)
	);
	return timePassed(nextFriday / 1000);
};

export const isFriday8AMTo9AM = () => {
	const now = new Date();
	return now.getUTCDay() == 5 && now.getUTCHours() == 8;
};

export function humanReadableDate(timestamp: number): string {
	return new Date(timestamp * 1000).toLocaleDateString('en-us', {
		year: 'numeric',
		month: 'long',
		day: 'numeric'
	});
}

export function timePassedOrHumanReadableDate(timestamp: number, thresholdDays: number): string {
	const now: number = +new Date();
	const showDate = now - timestamp * 1000 > thresholdDays * 24 * 60 * 60 * 1000;
	if (showDate) {
		return humanReadableDate(timestamp);
	} else {
		return timePassed(timestamp);
	}
}
